module.exports = __webpack_public_path__ + "img/5-1.09d9984c.svg";